'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { useState } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { usePartnersDialog } from '../_hooks/usePartnersDialog';
import type { GuideChannelKey } from '../_utils/guide/guideContent';
import { GUIDE_CHANNELS } from '../_utils/guide/guideContent';
import { GuideSection } from './home/GuideSection';
import { ChannelMark } from './link-card/ChannelMark';
const GUIDE_DIALOG_TITLE = '채널별 작성 가이드를 참고해주세요!';
export const GuideDialog = () => {
  const $ = _c(13);
  const {
    dialog,
    closeDialog
  } = usePartnersDialog();
  const [channel, setChannel] = useState("NAVER_BLOG");
  const t0 = dialog === "guide";
  let t1;
  if ($[0] !== channel) {
    t1 = GUIDE_CHANNELS.map(item => <button key={item.key} aria-label={item.tab} aria-pressed={item.key === channel} className={cn(FOCUS_RING, "flex size-54 items-center justify-center rounded-large border bg-Gray-50 transition-colors duration-150 motion-reduce:transition-none", item.key === channel ? "border-Gray-600" : "border-Gray-100 hover:border-Gray-300 active:border-Gray-400")} onClick={() => setChannel(item.key)}><ChannelMark channel={item.key} className="size-28 rounded-xsmall" /></button>);
    $[0] = channel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex gap-12">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== channel) {
    t3 = <GuideSection channel={channel} isCollapsible={false} />;
    $[4] = channel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-16 pb-24">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== closeDialog || $[10] !== t0 || $[11] !== t4) {
    t5 = <ResponsiveDialog opened={t0} onClose={closeDialog} drawerType="bottom" modalHeader={GUIDE_DIALOG_TITLE}>{t4}</ResponsiveDialog>;
    $[9] = closeDialog;
    $[10] = t0;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};